import React from "react";

export const Languages = () => {
  return (
    <>
      <h3>Languages</h3>
      <div>Ukrainian - native</div>
      <div>English - B2</div>
    </>
  );
};
